export const TYPE = {
  BAI_VIET: 4,
};
